<section class="flex flex-col gap-18 bg-white py-16">
  <div class="mx-auto max-w-page px-4 sm:px-6 lg:px-8">
    <div class="grid gap-10 lg:grid-cols-[1fr_auto] lg:items-end">
      <div class="flex flex-col gap-8">
        <h1 class="max-w-4xl text-hero font-light text-slate-950">
          Forms that turn data into decisions
        </h1>

        <p class="max-w-2xl text-body1 leading-8 text-slate-600">
          Build polished forms in minutes, capture submissions in one workspace, and uncover AI-powered insights
          that help your team act faster with confidence.
        </p>

        <div class="flex flex-wrap items-center gap-x-6 gap-y-3 text-body2 font-medium text-slate-700">
          <div class="flex items-center gap-2">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              class="h-4 w-4 text-slate-900"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
              stroke-width="2">
              <path
                stroke-linecap="round"
                stroke-linejoin="round"
                d="M9 12h6m-6 4h6M7 4h10a2 2 0 012 2v12a2 2 0 01-2 2H7a2 2 0 01-2-2V6a2 2 0 012-2z" />
            </svg>
            Form creation
          </div>

          <div class="flex items-center gap-2">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              class="h-4 w-4 text-slate-900"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
              stroke-width="2">
              <path
                stroke-linecap="round"
                stroke-linejoin="round"
                d="M8 10h8m-8 4h5m-7 6h10a2 2 0 002-2V6a2 2 0 00-2-2H8a2 2 0 00-2 2v12a2 2 0 002 2z" />
            </svg>
            Data submissions
          </div>

          <div class="flex items-center gap-2">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              class="h-4 w-4 text-slate-900"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
              stroke-width="2">
              <path
                stroke-linecap="round"
                stroke-linejoin="round"
                d="M13 10V3L4 14h7v7l9-11h-7z" />
            </svg>
            AI insights
          </div>
        </div>
      </div>

      <div>
        <a
          routerLink="/signup"
          class="inline-flex h-12 items-center justify-center gap-3 rounded-full bg-slate-950 px-8 text-body2 font-semibold text-white transition hover:bg-slate-800">
          Start free
          <app-svg-icon src="assets/icons/arrow-right.svg"></app-svg-icon>
        </a>
      </div>
    </div>
  </div>

  <div
    id="home-app-preview-section"
    class="relative mx-4 overflow-hidden rounded-2xl sm:mx-6 lg:mx-8">
    <div
      class="absolute inset-0 bg-cover bg-center"
      style="background-image: url('../../../../../assets/images/landing/mountain-1.webp');">
    </div>
    <div class="absolute inset-0 bg-white/25"></div>

    <div class="relative mx-auto max-w-page px-4 py-12 sm:px-6 sm:py-16 lg:px-8">
      <div
        class="w-full origin-top rounded-[2rem] border border-slate-200 bg-slate-100 p-2 shadow-2xl shadow-slate-950/10 transition-transform duration-150 ease-linear [will-change:transform]"
        [style.transform]="'scale(' + previewScale() + ')'">

        <div class="overflow-hidden rounded-[1.5rem] border border-slate-200 bg-white">
          <div class="flex items-center gap-2 border-b border-slate-200 bg-white px-5 py-4">
            <span class="h-3 w-3 rounded-full bg-error-400"></span>
            <span class="h-3 w-3 rounded-full bg-warning-400"></span>
            <span class="h-3 w-3 rounded-full bg-success-400"></span>
          </div>

          <div class="relative w-full bg-white">
            <img
              src="assets/images/landing/app.webp"
              alt="FormOps Dashboard"
              width="1600"
              height="936"
              fetchpriority="high"
              decoding="async"
              class="block h-auto w-full object-cover" />
          </div>
        </div>
      </div>
    </div>
  </div>
</section>
